// Path: src\Components\Popup\More\InviteCodePopup.jsx
import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Popup from "../Popup/BasePopup";
import Button from '../CommonFields/Button';
import TextInput from '../CommonFields/TextInput';
import { tournamentByCode } from "../../api/tournament.api";
import { contestByCode } from "../../api/contest.api";
import { scrimByCode } from "../../api/scrim.api";
import { toastError } from "../../Utilities/toast";

import TournamentViaCode from "../Common/JoinViaTournamentCode";
import ContestViaCode from "../Common/JoinViaContestCode";
import ScrimViaCode from "../Common/JoinViaScrimCode";

const JoinViaInviteCodePopup = ({ inviteCode }) => {
  const [error, setError] = useState("");
  const [helperText, setHelperText] = useState("");
  const [isTournament, setIsTournament] = useState(false);
  const [isContest, setIsContest] = useState(false);
  const [isPrivateContest, setIsPrivateContest] = useState(false);
  const [joinViaCodeTournament, setJoinViaCodeTournament] = useState({});
  const [joinViaCodeContest, setJoinViaCodeContest] = useState({});
  const [joinViaCodePrivateContest, setJoinViaCodePrivateContest] = useState({});

  const { t } = useTranslation();

  useEffect(() => {
    setJoinViaCodeTournament({});
    setJoinViaCodeContest({});
    setJoinViaCodePrivateContest({});
    setIsTournament(false)
    setIsContest(false)
    setIsPrivateContest(false)

    handleTournamentByCode(inviteCode)
  }, [inviteCode])

  async function handleTournamentByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await tournamentByCode(payload);
        if (response?.success && response?.data) {
          localStorage.setItem("activeGame", response?.data?.gameAry?.name);
          localStorage.setItem("activeGameId", response?.data?.gameAry?._id);
          localStorage.setItem("activeGameTypeId", response?.data?.gameTypeAry?._id);
          setJoinViaCodeTournament(response?.data);
          setIsTournament(true)
          setIsContest(false)
          setIsPrivateContest(false)
          //setInviteCode('');
        } else {
          handleContestByCode(code)
        }
      } catch (error) {
        handleContestByCode(code)
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeTournament({});
      setJoinViaCodeContest({});
      setJoinViaCodePrivateContest({});
      setIsTournament(false)
      setIsContest(false)
      setIsPrivateContest(false)
    }
  }

  async function handleContestByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await contestByCode(payload);
        if (response?.success && response?.data) {
          localStorage.setItem("activeGame", response?.data?.gameAry?.name);
          localStorage.setItem("activeGameId", response?.data?.gameAry?._id);
          localStorage.setItem("activeGameTypeId", response?.data?.gameTypeAry?._id);
          setJoinViaCodeContest(response?.data);
          setIsTournament(false)
          setIsContest(true)
          setIsPrivateContest(false)
          //setInviteCode('');
        } else {
          handleScrimByCode(code)
        }
      } catch (error) {
        handleScrimByCode(code)
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeTournament({});
      setJoinViaCodeContest({});
      setJoinViaCodePrivateContest({});
      setIsTournament(false)
      setIsContest(false)
      setIsPrivateContest(false)
    }
  }

  async function handleScrimByCode(code) {
    if (code?.trim()) {
      try {
        let payload = {
          user: JSON?.parse(localStorage?.getItem('profile'))?.user_id,
          code: code
        };
        let response = await scrimByCode(payload);
        if (response?.success && response?.data) {
          localStorage.setItem("activeGame", response?.data?.gameAry[0]?.name);
          localStorage.setItem("activeGameId", response?.data?.gameAry[0]?._id);
          localStorage.setItem("activeGameTypeId", response?.data?.gameTypeAry[0]?._id);

          setJoinViaCodePrivateContest(response?.data);
          setIsTournament(false)
          setIsContest(false)
          setIsPrivateContest(true)
          //setInviteCode('');
        } else {
          toastError(t('tournament_list.tournament_not_found'));
          setJoinViaCodeTournament({});
          setJoinViaCodeContest({});
          setJoinViaCodePrivateContest({});
          setIsTournament(false)
          setIsContest(false)
          setIsPrivateContest(false)
          //setInviteCode('');
        }
      } catch (error) {
        toastError(t('tournament_list.tournament_not_found'));
        setJoinViaCodeTournament({});
        setJoinViaCodeContest({});
        setJoinViaCodePrivateContest({});
        setIsTournament(false)
        setIsContest(false)
        setIsPrivateContest(false)
        //setInviteCode('');
      }
    }
    else {
      toastError(t('errors.error_please_enter_invite_code'));
      setJoinViaCodeTournament({});
      setJoinViaCodeContest({});
      setJoinViaCodePrivateContest({});
      setIsTournament(false)
      setIsContest(false)
      setIsPrivateContest(false)
    }
  }

  return (
    <>
      {isTournament && <TournamentViaCode joinViaCodeTournament={joinViaCodeTournament} />}
      {isContest && <ContestViaCode joinViaCodeContest={joinViaCodeContest} />}
      {isPrivateContest && <ScrimViaCode joinViaCodePrivateContest={joinViaCodePrivateContest} />}
    </>
  );
};

export default JoinViaInviteCodePopup;
